var exports = {
  "w4": "fileHeader__nfaKOG",
  "Cl": "fileHeaderExpandable__d1l_Hh",
  "Wh": "flexRow__GjwQ3z",
  "M9": "repoAvatar__mcU10e",
  "Qq": "repoName__XSffnj",
  "X1": "expandButton__CmjOev",
  "wY": "tableWrapper__twJerf",
  "As": "truncatedPath__i0WCjx",
  "xp": "counterLabel__5Q4gYb",
  "Yl": "resultsGroup__16NwE7",
  "OE": "showMoreWrapper__h1AqFY",
  "dO": "showMoreButton__7fY6hs",
};

module.exports = exports;
